<template>
  <div class="modal-goodslist">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px">子设备绑定</div>
        <button type="button" class="btn-close" @click="closeSelf">关闭</button>
      </div>
      <div class="modal-body" style="padding:20px;">
          <template>
            <el-table :data="tableData" :height="th" border v-loading="loading" style="width: 100%">
                <el-table-column prop="zone" label="地点"></el-table-column>
                <el-table-column prop="deviceName" label="设备名称"></el-table-column>
            </el-table>
          </template>
        
      </div>
    </div>
  </div>
</template>

<script>
import { timeStr } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import { getStaffCode } from "@/utils/auth";

export default {
  name: "Add",
  data() {
    return {
      loading: false,
      tableData: null,
      th:0,
    };
  },
created(){
    this.th = this.$store.state.tableHeight;
  },
methods: {
    init(row) {
      this.getChildList(row);
    },
    getChildList(row) {
        
      let gatewayId = row.gatewayId;
      this.loading = true;
      this.$axios({
        method: "post",
        url: this.$deviceUrl + "YJGateway/GetMeshDeviceList",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          gatewayId: gatewayId,
        },
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          console.log(response.data);
          this.tableData = response.data.data;
        } else if (response.data.error == 1) {
          this.$message({ type: "info", message: response.data.message });
        }
      });
    },
    closeSelf() {
      this.$emit("closeDetails");
    },
    
  },
};
</script>





<style lang="scss" scoped>
.modal-goodslist {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .modal {
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width: 800px;

    .modal-header {
      border-bottom: 1px solid #eee;
      color: #313131;
      justify-content: space-between;
      padding: 10px;
      display: flex;
    }
    .modal-body {
      position: relative;
      padding: 20px 0px;
      z-index: 99;
      height: 100%;
    }
    .modal-footer {
      border-top: 1px solid #eee;
      justify-content: flex-end;
      padding: 15px;
      display: flex;
    }
  }
}

.btn-close,
.btn-confirm {
  border-radius: 8px;
  margin-left: 16px;
  width: 56px;
  height: 36px;
  border: none;
  cursor: pointer;
}
.btn-close {
  color: #313131;
  background-color: transparent;
}

.row {
  padding: 10px 0px;
}
.item {
  padding: 0px 20px;
}
.label {
  padding: 5px 0px;
}
</style>
